<script>
    // @ts-nocheck
    import {
        Alert,
        FormBox,
        Banner,
        TextArea,
        InputText,
        Button,
        Row,
        Column,
        Link,
        Chip,
        Spinner,
        InputFile,
        InputTag,
        Typography,
        Modal,
        BackDrop,
    } from '$lib/components/UI'
    import DocumentField from '$lib/components/UI/DocumentField.svelte'
    import Select from '$lib/components/UI/Select2.svelte'
    import OfferDocInput from '$lib/custom/components/OfferDocInput.svelte'
    import LoadInvoiceSin from '$lib/custom/components/LoadInvoiceSin.svelte'
    import createDataStore from '$lib/stores/datastore'
    import Remito from '$lib/custom/components/Remito.svelte'
    import offer, { offers } from '$lib/services/collections/offers'
    import user from '$lib/stores/user'
    import dictionaries from '$lib/stores/dictionaries'
    import persistant_flags from '$lib/stores/persistant_flags'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import { API_URL } from '$lib/conf'
    import Content from '$lib/components/layout/Content.svelte'
    import { DamageInvoice } from '$lib/services/interfaces'
    import { createEventDispatcher, getContext, onMount, onDestroy } from 'svelte'
    import { currencyFormatter, sleep, strftime, areEquals } from '$lib/utils'
    import { fly } from 'svelte/transition'
    import Reclamo from './Reclamo.svelte'
    import { navigate } from 'svelte-navigator'
    import Disclosure from '$lib/components/UI/Disclosure.svelte'
    import ModalX from '$lib/components/UI/ModalX.svelte'
    export let claim = false
    export let waiting = false
    export let data = {}
    // export let openClaims = false
    export let enableToOpenClaim = false
    export let enableToUpdate = false
    const dispatch = createEventDispatcher()
    const toast = getContext('toast')
    let claimData = {
        id_oferta: data.id,
    }
    // let autosync = setInterval(async () => {
    //     data = await offer.get(data.id)
    // }, 15000)
    // onMount(() => {
    //     // offers.sync()
    //     return () => {
    //         clearInterval(autosync)
    //     }
    // })
    // onDestroy(() => { clearInterval(autosync) })
    async function onSendClaim() {
        dispatch('send_claim', { data: claimData })
    }
    async function sendDocumentation({ detail: payload }) {
        console.log({ payload })
        // @ts-ignore
        waiting = true
        return user.fetch(`${API_URL}/offers/${$user?.defaultAccount}/${data.id}`, {
            method: 'PUT',
            body: JSON.stringify(payload),
        })
            .then(async (req) => {
                if (req.ok) {
                    toast && toast.success('Documento adjuntado', { duration: 4000 });
                    sleep(4000).then(async () => {
                        window.location.reload()
                        // let tmp = await offer.get(data.id)
                        // console.log({data: tmp})
                        // data = tmp
                    })
                } else {
                    throw new Error('No se pudo adjuntar la documentación')
                }
            })
            .catch((err) => {
                toast && toast.error(err.message, { duration: 4000 })
                waiting = false
            })
    }
    function confirmDelivery() {
        waiting = true
        return user.fetch(`${API_URL}/offers/${$user?.defaultAccount}/${data.id}`, {
            method: 'PUT',
            body: JSON.stringify({ entregar: {} }),
        })
            .then(async (req) => {
                if (req.ok) {
                    toast && toast.success('Entrega confirmada.',{ duration: 4000 });
                    sleep(4000).then(async () => {
                        window.location.reload()
                        // let tmp = await offer.get(data.id)
                        // console.log({data: tmp})
                        // if(!areEquals(data, tmp)){
                        //     data = tmp
                        // }
                    })
                } else {
                    throw new Error(
                        'No se pudo confirmar la entrega. Intente más tarde.'
                    )
                }
            })
            .catch((err) => {
                toast && toast.error(err.message, { duration: 4000 })
                waiting = false
            })
    }
    const schema = {
        categoria: {
            label: 'Categoría',
            render: (v) =>
                $dictionaries?.lic_items_polaris.find((i) => i.value === v)
                    ?.label,
        },
        producto: {
            render: (v) =>
                $dictionaries?.lic_items_polaris.find((i) => i.value === v)
                    ?.label,
        },
        descripcion: { label: 'Descripción' },
        cantidad: {},
        precio_unitario: {
            render: (v) =>
                currencyFormatter({ n: v, lang: 'es-AR', type: 'ARS' }),
        },
        total: {
            render: (v) =>
                currencyFormatter({ n: v, lang: 'es-AR', type: 'ARS' }),
        },
    }
    const dataItems = createDataStore(
        data?.items.filter((item) => item.compra == '1') || [],
        null
    )
    // console.clear && console.clear()
    let selected = []
    $: if (claim === false) {
        selected = []
    }
    //    $: if(waiting === false) {
    //     claimData = {id_oferta: data.id}
    //    }
    $: claimData.items = selected.map((x) => dataItems.get(x)).filter((x) => x)
    let claimDataValidation = {}
    $: validClaim = Object.values(claimDataValidation).every(x => x) && claimData.asunto && claimData.asunto.length > 0
    // @ts-ignore
    $: claimData.author = $user?.shortName
    $: openClaims = data?.claims?.filter((claim) => !claim.closed).length || 0
    $: enableToOpenClaim = openClaims == 0 && data.state !== 'Ingresada'
    $: enableToUpdate = [
        'Adjudicada',
        'Remito adjuntado',
        'Entregado',
    ].includes(data.state)
    let currentClaim = null
    async function getClaimData(id) {
        // @ts-ignore
        return user.fetch(`${API_URL}/claims/${$user?.defaultAccount}/${id}`)
        .then(async (req) => {
            if (req.ok) {
                return await req.json()
            } else {
                throw new Error('No se pudo cargar el reclamo')
            }
        })
    }
    let dataForm = {}
    let viewRemito = false
    let downloadRemito
    $: console.log({xdata: data})
    const maskState = state => /^Revisi.*$/i.test(state) ? 'En Revisión' : state
</script>
{#key data}
<Banner
    label="OFERTA"
    title={`${data.id_oferta}`}
    info={[
        // {label: 'Estado', value: 'Adjudicada'},
        { label: 'Sucursal', value: data?.sucursal_nombre },
        { label: 'Tiempo de entrega', value: data?.tiempo_entrega !== '12' ? data?.tiempo_entrega + 'hs' : 'Inmediata'},
        {
            label: 'Monto total',
            value: currencyFormatter({
                n: data?.monto_total,
                lang: 'es-AR',
                type: 'ARS',
            }),
        },
    ]}
/>
{/key}
<Content
    style="display: flex; flex-direction: column;gap: 35px; width: 100%; padding: 25px 68px 68px 68px"
>
    {@const observacion = data.observacion_anulacion || data.observacion}
    {#if observacion}
        <Alert type="error">{@html observacion.replace(/\n/g, '<br/>')}</Alert>
    {/if}
    <FormBox.Container title="Licitación">
        <FormBox.Row>
            <FormBox.Cell label="Referencia">
                {#if data?.id_licitacion}
                    <Link
                        href={`/home/licitaciones/${data.id_licitacion}/view`}
                    >
                        {data?.id_licitacion}
                    </Link>
                {:else}
                    ...
                {/if}
            </FormBox.Cell>
            <FormBox.Cell label="Estado" value={maskState(data?.state || '...')} />
        </FormBox.Row>
        <FormBox.Row>
            <FormBox.Cell
                label="Fecha de inicio"
                value={strftime('%d/%m/%Y', data?.creation_date) || '...'}
            />
            <FormBox.Cell
                label="Jurisdiccion"
                value={data?.asegurado?.jurisdiccion || '...'}
            />
        </FormBox.Row>
        <FormBox.Row>
            <FormBox.Cell
                label="Siniestro"
                value={data?.id_siniestro || '...'}
            />
            <FormBox.Cell
                label="Código Infoauto"
                value={data?.codigo_infoauto || '...'}
            />
            <FormBox.Cell
                label="Patente"
                value={data?.vehiculo?.patente || '...'}
            />
        </FormBox.Row>
        <FormBox.Row>
            <FormBox.Cell
                label="Marca"
                value={data?.vehiculo?.marca || '...'}
            />
            <FormBox.Cell
                label="Modelo"
                value={data?.vehiculo?.modelo || '...'}
            />
        </FormBox.Row>
    </FormBox.Container>    
    {#if ['Adjudicada', 'Remito adjuntado', 'Entregado', 'Factura adjuntada', 'Finalizado'].includes(data.state)}
        <FormBox.Container title="Datos del asegurado">
            <FormBox.Row>
                <FormBox.Cell
                    label="Nombre completo"
                    value={data?.asegurado?.nombre_apellido_asegurado || '...'}
                />
                <FormBox.Cell
                    label="Email"
                    value={data?.asegurado?.email_asegurado || '...'}
                />
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell
                    label="Teléfono"
                    value={data?.asegurado?.telefono_asegurado || '...'}
                />
                <FormBox.Cell
                    label="Celular"
                    value={data?.asegurado?.celular_asegurado || '...'}
                />
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell
                    label="Calle"
                    value={data?.asegurado?.calle || '...'}
                />
                <FormBox.Cell
                    label="Altura"
                    value={data?.asegurado?.altura || '...'}
                />
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell
                    label="Provincia"
                    value={data?.asegurado?.jurisdiccion || '...'}
                />
                <FormBox.Cell
                    label="Código postal"
                    value={data?.asegurado?.cp || '...'}
                />
            </FormBox.Row>
        </FormBox.Container>
    {/if}

    {#if claim}
        <Row>
            <InputText
                label="Asunto del reclamo"
                bind:value={claimData.asunto}
                disabled={waiting}
                required
            />
                <!-- validation={v => typeof v == 'string' && v.length >= 3} -->
                <!-- bind:valid={claimDataValidation.asunto} -->
            <!-- <Select
                    label="Tipo de reclamo"
                    options={$dictionaries.lic_motivos_reclamos || []}
                    validation={v => v && ![null, '', undefined].includes(v)}
                    bind:value={claimData.tipo_reclamo}
                    bind:valid={claimDataValidation.tipo_reclamo}
                    required
                /> -->
            </Row>
            <TextArea
                label="Mensaje"
                validation={(v) => v && v.length >= 15}
                bind:value={claimData.descripcion}
                bind:valid={claimDataValidation.descripcion}
                disabled={waiting}
                style="margin-top: -50px"
                />
        {#if claimData.descripcion && !claimDataValidation.descripcion}
            <Alert type="error">
                Por favor agregue una descripción más extensa.
            </Alert>
        {/if}
    {/if}
    <FormBox.Container
        title={claim ? 'Seleccione los items relacionados' : 'Detalle de items'}
    >
        <FormBox.Row>
            <Datatable
                {schema}
                bind:selected
                style={claim ? 'user-select: none' : ''}
                data={dataItems}
                unlockSelection
                selectable={claim}
            />
        </FormBox.Row>
    </FormBox.Container>
    {#if claim && selected.length < 1}
        <Alert type="info">
            Puede seleccionar el item relacionado al reclamo haciendo click
            sobre él.
        </Alert>
    {/if}
    {#if claim}
        <span style="display: flex; gap: 15px">
            <Button
                style="width: 17%"
                type="secondary"
                label="Cancelar"
                disabled={waiting}
                on:click={() => (claim = false)}
            />
            <Button
                style="width: 100%"
                disabled={waiting || !validClaim}
                label="Enviar reclamo"
                on:click={() => onSendClaim()}
            />
        </span>
    {/if}
    {#if data.claims?.length > 0}
        <FormBox.Container title="Reclamos relacionados">
            {#each data.claims as item (item.id)}
                <FormBox.Row>
                    <div
                        style="position: relative; width: 100%; padding: 0 24px;display: flex; justify-content: space-between; flex-direction: columns"
                    >
                        <Link
                            on:click={() =>
                                (currentClaim = getClaimData(item.id))}
                            >Ver documento</Link
                        >
                        <Chip
                            color={item.closed ? '#c0c0c0' : '#00669E'}
                            style="border-radius: 5px; font-width: 700"
                            >{item.closed ? 'Cerrado' : 'Abierto'}</Chip
                        >
                    </div>
                </FormBox.Row>
            {/each}
        </FormBox.Container>
    {/if}

    <!-- Cambios de costo -->
    {#if data?.offer_modifications?.length > 0}
        <FormBox.Container title="Cambios de costo relacionados">
            {#each data.offer_modifications as om}
                <Disclosure size="small">
                    <svelte:fragment slot="header">
                        <div
                            style="width:100%;display: flex;justify-content:space-between;margin-inline:24px;align-items:center"
                        >
                            <Typography
                                type="h5"
                                style={`font-weight: 500;color: var(--color-grey-800); margin: 0; padding: 0`}
                                >{om?.title}</Typography
                            >
                            <Chip
                                color={om.state == 'Rechazado'
                                    ? '#AF2219'
                                    : om.state == 'Aprobado'
                                      ? '#64AF73'
                                      : '#6F7072'}
                                style="border-radius: 5px; font-width: 700"
                                >{maskState(om?.state)}</Chip
                            >
                        </div>
                    </svelte:fragment>
                    <div style="margin-inline: 24px;">
                        <Typography
                            type="subtitle"
                            style="margin: 1rem 0 -10px 0"
                            color="grey-800">Importe adjudicado</Typography
                        >
                        <Typography type="body"
                            >${om?.monto_total_anterior}</Typography
                        >
                        <Typography
                            type="subtitle"
                            style="margin: 1rem 0 -10px 0"
                            color="grey-800">Importe solicitado</Typography
                        >
                        <Typography type="body">${om?.monto_total}</Typography>
                        <Typography
                            type="subtitle"
                            style="margin: 1rem 0 -10px 0"
                            color="grey-800">Observaciones</Typography
                        >
                        <Typography type="body">{om?.observaciones}</Typography>
                        <Typography
                            type="subtitle"
                            style="margin: 1rem 0 -10px 0"
                            color="grey-800">Fecha de creación</Typography
                        >
                        <Typography type="body"
                            >{om?.fecha_creacion.split('T')[0]}</Typography
                        >
                        {#if om.motivo}
                            <Alert
                                type={om.state == 'Aprobado' ? 'info' : 'error'}
                                ><strong>Motivo:</strong><br
                                />{@html om.motivo.replace(
                                    /\n/g,
                                    '<br/>'
                                )}</Alert
                            >
                        {/if}
                    </div>
                </Disclosure>
            {/each}
        </FormBox.Container>
    {/if}

    {#if (data.factura || data.remito) && !claim}
        <FormBox.Container title="Documentos relacionados">
            {#if data.factura}
                <DocumentField
                    title="Factura"
                    preview
                    config={{ preview: { label: 'Ir a la Factura' } }}
                    on:download={() => {
                        window.open(
                            DamageInvoice.download(data.factura.id),
                            '_blank'
                        )
                    }}
                    on:preview={() =>
                        window.open(
                            `/home/invoices/${data.factura.id}`,
                            '_self'
                        )}
                />
            {/if}
            {#if data.remito}
                <DocumentField
                    title="Remito"
                    on:download={() => {
                        window.open(
                            DamageInvoice.download(data.remito.id),
                            '_blank'
                        )
                    }}
                />
            {/if}
        </FormBox.Container>
    {/if}
    {#if data.state == 'Adjudicada'}
        <OfferDocInput
            title="Adjuntar Remito"
            legend="Seleccione documentos que pruebe el despacho de la mercaderia (Siendo el remito el primero)."
            button_label="Enviar remito"
            name="remito"
            allowMediaType={['pdf', 'jpeg', 'jpg']}
            maxFileSize="1.5MB"
            minDocuments={1}
            maxDocuments={3}
            preprocess={(x) => {
                let ret = {
                    ...x,
                    remito: x.remito
                }
                console.log({preprocessInput: x, preprocessOutput: ret})
                return ret
            }}
            validation={(v) => !!v.remito }
            bind:disabled={waiting}
            on:submit={sendDocumentation}
            lock={!(`${data.id_oferta}_downloaded` in $persistant_flags)}
        >
        <svelte:fragment slot="lockedView">
        </svelte:fragment>
        </OfferDocInput>
        <Button on:click={() => viewRemito=true}>Descargar remito</Button>
    {/if}
    {#if data.state == 'Entregado'}
        <LoadInvoiceSin
            preprocess={(x) => ({
                factura: {
                    ...(x.file && x.file.length > 0 ? x.file[0] : {}),
                    ...x,
                },
            })}
            bind:disabled={waiting}
            on:submit={sendDocumentation}
        />
    {/if}
    {#if data.state == 'Remito adjuntado'}
        <Button
            label="Confirmar entrega"
            disabled={waiting}
            on:click={confirmDelivery}
        />
    {/if}
    {#if data.state == 'Factura adjuntada' && data.factura === null}
    <Button
    label="Cargar otra factura"
    on:click={() => window.open('/home/invoices', '_self')}
    />
    {/if}
</Content>
{#if currentClaim}
    <div class="class4" transition:fly={{ x: 50 }}>
        {#await currentClaim}
            <span
                style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; position: absolute"
            >
                <Spinner />
            </span>
        {:then claim}
            <Reclamo on:back={() => (currentClaim = false)} {claim} />
        {:catch e}
            {e.message}
        {/await}
    </div>
{/if}

<BackDrop style="position: fixed; z-index: 999999999999" visible={viewRemito}>
    <Modal
        style="height: calc(100% - 100px); max-width: 250mm; width: calc(100% - 100px)"
        title="Descargar Remito"
        on:close={() => viewRemito = false}
        on:clickout={() => viewRemito = false}
        closeable
    >
        <Remito bind:downloadAction={downloadRemito} data={data} on:download={() => {
            persistant_flags.add(`${data.id_oferta}_downloaded`, true)
            viewRemito = false
        }}/>
        <svelte:fragment slot="buttonSet">
            <Button label="Descargar" on:click={downloadRemito}/>
        </svelte:fragment>
    </Modal>
</BackDrop>
<style>
    .class4 {
        top: 0;
        right: 0;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        position: fixed;
        height: 100%;
        background: white;
        z-index: 5;
    }
</style>